import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchExpenseCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('budget/expense-category', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteExpenseCategory(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`budget/expense-category/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
